import { createSlice } from "@reduxjs/toolkit";
import { HomePropType } from "./types";

const initialStateValue: HomePropType = {
  categories: [],
  categoryLoading: true,
  singleProduct: [],
  singleProductLoading: true,
  products: [],
  productsLoading: true,
};

export const homeSlice = createSlice({
  name: "home",
  initialState: { value: initialStateValue },
  reducers: {
    setHome: (state, action) => {
      state.value = { ...state.value, ...action.payload };
    },
  },
});

export const { setHome } = homeSlice.actions;
export default homeSlice.reducer;
